import { CartDto, DeliveryMethodDto } from '../../generated-api';
import { calcTotalServiceCharge } from '../utils/cart';
import { useCartStore } from '../context/cart/CartStore';
import { shallow } from 'zustand/shallow';

export const rightPrice = (vatType: string, eatInPrice: number, takeawayPrice: number | undefined) => {
  if (vatType === 'EAT_IN' || takeawayPrice === undefined) {
    return eatInPrice;
  }
  return takeawayPrice;
};

export const useTotalPrice = (): number => {
  const { vatType, totalPrice, totalTakeawayPrice } = useCartStore(
    (s) => ({
      vatType: s.cart.vatType,
      totalPrice: s.cart.totalPrice,
      totalTakeawayPrice: s.cart.totalTakeawayPrice,
    }),
    shallow
  );

  return rightPrice(vatType, totalPrice, totalTakeawayPrice);
};

export const useServiceCharge = (deliveryMethod: DeliveryMethodDto) => {
  const totalPrice = useTotalPrice();

  if (deliveryMethod.serviceChargeAmount && deliveryMethod.serviceChargeAmount > 0) {
    return calcTotalServiceCharge(totalPrice, deliveryMethod.serviceChargeAmount);
  }

  return 0;
};

export const useOriginalTotalPrice = () => {
  const { getOriginalTotalPrice, vatType } = useCartStore((x) => ({
    vatType: x.cart.vatType,
    getOriginalTotalPrice: x.getOriginalTotalPrice,
  }));

  const { totalPrice, totalTakeawayPrice } = getOriginalTotalPrice();

  return rightPrice(vatType, totalPrice, totalTakeawayPrice);
};

export const getEffectiveTotalPrice = (cart: CartDto) => {
  return rightPrice(cart.vatType, cart.totalPrice, cart.totalTakeawayPrice);
};
